import { find, get } from 'lodash';
import { isVanWestendorpGroup } from 'utils/nodeTypes';
import { pipingRegExAll } from 'components/FormattedInput/helpers';
import { PIPE_EXPRESSION_MATCHING } from 'components/FormattedInput/constants';
import { getTransformedPromptForVariables } from 'containers/QuestionnairePage/utils';
const MAX_PIPED_QUESTION_LENGTH = 36;

export const hasMention = (question) =>
  question.hasPiping &&
  new RegExp(pipingRegExAll).exec(question.htmlPrompt || question.prompt);

export const getUpdatedPrompt = ({
  prompt,
  nodes = [],
  screeningQuestions = [],
  questionGroups = [],
  replaceVariables = false,
  variableIndex,
}) => {
  const pipingRegEx = new RegExp(pipingRegExAll);
  const updatedPrompt = String(prompt);
  const promptParts = [];
  let match;
  let stringIndexStart = 0;

  do {
    match = pipingRegEx.exec(updatedPrompt);
    if (match) {
      const pipedQuestionRefId = match[PIPE_EXPRESSION_MATCHING.REF_ID];
      let isScreening = false;

      let pipedQuestionIndex = nodes.findIndex((question) => {
        if (question.refId === pipedQuestionRefId) {
          return true;
        }

        return false;
      });
      if (pipedQuestionIndex === -1) {
        pipedQuestionIndex = screeningQuestions.findIndex((question) => {
          if (question.refId === pipedQuestionRefId) {
            isScreening = true;
            return true;
          }

          return false;
        });
      }

      if (pipedQuestionIndex !== -1) {
        let pipedQuestion;
        if (!isScreening) {
          pipedQuestion = nodes[pipedQuestionIndex];
        } else {
          pipedQuestion = screeningQuestions[pipedQuestionIndex];
        }

        if (!pipedQuestion) return prompt;

        let pipedQuestionPrompt = pipedQuestion.prompt;
        // let pipedSubPrompt;
        // We are not handling nested piping so we are replacing the 2nd level piping with double underscores
        // double underscore is the placeholder chosen for the piped question of a piped question
        pipedQuestionPrompt = pipedQuestionPrompt.replace(
          // IMPORTANT: You need to create a new RegEx here, or the matcher in the do/while will go into a loop
          // starting from scratch. Its important and you should keep it.
          new RegExp(pipingRegEx),
          '__',
        );

        pipedQuestionPrompt =
          pipedQuestionPrompt.length > MAX_PIPED_QUESTION_LENGTH
            ? `${pipedQuestionPrompt.substr(0, MAX_PIPED_QUESTION_LENGTH)}...`
            : pipedQuestionPrompt;

        // add piped question subPrompt (depending on what the pipedSubRefId refers to)
        if (isVanWestendorpGroup(pipedQuestion)) {
          // console.debug({ pipedQuestion, nodes });
          // pipedSubPrompt=pipedQuestion.find(({refId})=>refId === pipedSubRefId)
        }

        // prepend text
        const finalizedPrompt = `<span class="piped-question"><span class="text-weight-bold">
          ${isScreening ? 'SQ' : 'Q'}${pipedQuestionIndex + 1}</span>
            ${pipedQuestionPrompt}
            <span class="icon icon-close color-grey-10 margin-left-tiny" style="font-size:9px;"></span>
          </span>`;

        // position text into place
        const currentTextPart = updatedPrompt.substr(
          stringIndexStart,
          match.index - stringIndexStart,
        );
        promptParts.push(currentTextPart);

        promptParts.push(finalizedPrompt);

        stringIndexStart = pipingRegEx.lastIndex;
      } else if (
        match[PIPE_EXPRESSION_MATCHING.ATTRIBUTE_REF_ID] &&
        replaceVariables
      ) {
        const variableRefId = match[PIPE_EXPRESSION_MATCHING.ATTRIBUTE_REF_ID];

        const questionGroup = find(questionGroups, (group) =>
          group.attributes?.some((attr) => attr.refId === variableRefId),
        );

        if (!questionGroup) {
          return prompt;
        }

        const updatedPromptWithVariables = getTransformedPromptForVariables({
          questions: nodes,
          question: { prompt },
          questionGroups,
          attributes: questionGroup?.attributes || [],
          screeningQuestions,
          index: variableIndex,
        }).formattedParts;

        return updatedPromptWithVariables;
      }
    }
  } while (match);

  if (promptParts.length > 0 && stringIndexStart < prompt.length) {
    const text = updatedPrompt.substr(stringIndexStart);
    promptParts.push(text);
  }

  if (promptParts.length > 0) {
    return promptParts.join(' ');
  }

  return prompt;
};

export const getTicksFromQuestion = (question) => {
  const ticks = get(question, 'slider.ticks', []);

  return ticks;
};

export const stripHTMLTags = (str) =>
  str?.replace(/<\/?("[^"]*"|'[^']*'|[^>])*(>|$)/g, '');
